import { useEffect, useState } from 'react';
import { getCreateSharedObjectsPermission } from '../../../services/common/shared-object-permission';

export const useCreateSharedObjectsPermission = () => {
	const [hasSharedObjectsPermission, sethasSharedObjectsPermission] = useState<boolean>();

	useEffect(() => {
		getCreateSharedObjectsPermission().then((data) => {
			sethasSharedObjectsPermission(data);
		});
	}, []);

	return {
		hasSharedObjectsPermission,
	};
};
